import {Formik} from 'formik';
import * as Yup from 'yup';
import * as css from './AddCategory.css';
import Btn from '../../../../../../../component/button/btn/Btn';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Input from '../../../../../../../component/input/Input';
import {addCategory} from '../../../../../../../redux/categories/categoriesActions';
import {yupStringMin} from '../../../../../../../functions/validationsYup';

interface AddCategoryProps {
    close: () => void;
    onCategoryAdded?: (categoryId: number) => void;
}

function AddCategory({close, onCategoryAdded}: AddCategoryProps) {
    const {t} = useTranslation('newEvent');
    const {t: tLayout} = useTranslation('layout');
    const {t: globalT} = useTranslation('global');
    const pid = useSelector((s: any) => s.account.pid);

    const validationSchema = Yup.object().shape({
        categoryTitle: yupStringMin(2).required(globalT('errorRequired'))
    });

    const handleSubmit = async (values: {categoryTitle: string}) => {
        try {
            const res = await addCategory({pid: pid, title: values.categoryTitle});
            // The addCategory action returns the new category in res.newCategory
            if (res?.newCategory && onCategoryAdded) {
                onCategoryAdded(res.newCategory.catId);
            }
            close();
        } catch (error) {
            console.error('Error adding category:', error);
        }
    };

    return (
        <Formik
            initialValues={{categoryTitle: ''}}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({values, errors, handleSubmit}) => (
                <css.wrap>
                    <Input 
                        name={'categoryTitle'} 
                        text={t('categoryTitle')} 
                        dataCy="enterCategoryName"
                        icon={undefined}
                        events={undefined}
                        className={undefined}
                        forwardRef={undefined}
                    />
                    <css.buttonsWrapper>
                        <Btn disabled={!!errors.categoryTitle || !values.categoryTitle} onClick={handleSubmit}>{t('continue')}</Btn>
                        <Btn onClick={close}>{tLayout('closeIt')}</Btn>
                    </css.buttonsWrapper>
                </css.wrap>
            )}
        </Formik>
    );
}

export default AddCategory;

